import React, { useEffect, useRef } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { useAppSelector } from "../../core/data/redux/hooks";

interface ProtectedRouteProps {
  allowedRoles?: string[];
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  allowedRoles,
  children,
}) => {
  const token = useAppSelector((state) => state.auth.token);
  const userRole = useAppSelector((state) => state.auth.role);
  const location = useLocation();

  const navigate = useNavigate();
  const hasNavigatedRef = useRef(false);

  const layoutPages =
    location.pathname === "/coming-soon" ||
    location.pathname === "/under-maintenance" ||
    location.pathname === "/under-construction";

  if (!token || (allowedRoles && !allowedRoles.includes(userRole || ""))) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return (
    <div
      className={`bg-linear-gradiant ${
        layoutPages ? "d-flex align-items-center justify-content-center" : ""
      }`}
    >
      <div className="main-wrapper">{children}</div>
    </div>
  );
};

export default ProtectedRoute;
